import ApiService from './ApiService';
import * as queryString from 'query-string';

export default class UserService {
  findAll(query = {}) {
    return ApiService.get(`/users?${queryString.stringify(query)}`);
  }

  getExpiredUsersCount() {
    return ApiService.get(`/users/expired`);
  }

  getCurrentUsersCount() {
    return ApiService.get(`/users/current`);
  }

  getMonthlyActiveUsersCount(from, to) {
    return ApiService.get(`/users/monthly-active-users/${from}/${to}`);
  }

  getMonthlyNewUsersCount(from, to) {
    return ApiService.get(`/users/monthly-new-users/${from}/${to}`);
  }

  infoById(id) {
    return ApiService.get(`/users/info/${id}`);
  }

  generatePassword(id, data) {
    const queryParams = new URLSearchParams(data).toString();
    return ApiService.get(`/users/generate-password/${id}?${queryParams}`);
  }

  changePlan(id, tp_user) {
    return ApiService.post(`/users/set-subscription-type/${id}`, { tp_user });
  }

  update(id, body) {
    return ApiService.patch(`/users/${id}`, body);
  }

  changeExpirationTimePlan(id, data) {
    return ApiService.patch(`/users/expiration-plan/${id}`, data);
  }
}
